import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogImageAlt?: string;
  canonical?: string;
  type?: "website" | "article" | "video.other";
  videoUrl?: string;
  videoType?: string;
  twitterCard?: "summary" | "summary_large_image" | "player";
}

export const SEO = ({
  title,
  description,
  keywords,
  ogImage = "https://autoquizai.com/og-image.jpg",
  ogImageAlt,
  canonical,
  type = "website",
  videoUrl,
  videoType = "video/mp4",
  twitterCard = "summary_large_image",
}: SEOProps) => {
  const fullTitle = title.includes("AutoQuiz AI")
    ? title
    : `${title} | AutoQuiz AI`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {keywords && (
        <meta name="keywords" content={keywords} />
      )}

      {canonical && (
        <link rel="canonical" href={canonical} />
      )}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {ogImageAlt && (
        <meta property="og:image:alt" content={ogImageAlt} />
      )}

      {canonical && (
        <meta property="og:url" content={canonical} />
      )}

      {videoUrl && (
        <>
          <meta property="og:video" content={videoUrl} />
          <meta
            property="og:video:secure_url"
            content={videoUrl}
          />
          <meta
            property="og:video:type"
            content={videoType}
          />
        </>
      )}

      <meta
        name="twitter:card"
        content={twitterCard}
      />
      <meta
        name="twitter:title"
        content={fullTitle}
      />
      <meta
        name="twitter:description"
        content={description}
      />
      <meta
        name="twitter:image"
        content={ogImage}
      />

      {ogImageAlt && (
        <meta
          name="twitter:image:alt"
          content={ogImageAlt}
        />
      )}
    </Helmet>
  );
};
